import api from '@/services/api/config';

const path = 'v1/wareneingangspruefung/admin/wareneingangspruefung';

export default {
  get: (page, size, sort = null, desc = false, suche = null, status = null) => api.get(path, {
    params: {
      page, size, sort, desc, suche, status,
    },
  }),
  getById: (id) => api.get(`${path}/${id}`),
  create: (wareneingangspruefung) => api.post(path, wareneingangspruefung),
  update: (id, wareneingangspruefung) => api.put(`${path}/${id}`, wareneingangspruefung),
  delete: (id) => api.delete(`${path}/${id}`),
  finalisieren: (id) => api.patch(`${path}/${id}/finalisieren`),
  archivieren: (id) => api.patch(`${path}/${id}/archivieren`),
  getGueltigkeitsbereichKollision: (id, gueltigAbParam, gueltigBisParam, artikelnummer) => api.get(`${path}/${id}/gueltigkeitsbereich/kollision`, {
    params: {
      gueltig_ab: gueltigAbParam, gueltig_bis: gueltigBisParam, artikelnummer,
    },
  }),
};
